import { OrganizationApi, ToastStateHandler } from '../../../api';
import { dispatch } from '../../../store';
import { deleteHoliday } from '../../../store/slices/holiday.slice';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpDeleteHoliday = () => {
    const { t } = useTranslation('newNotifications');
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (id: string, callback: { onSuccess?: (data: any) => void }) => {
        return new Promise<any>((resolve, reject) => {
            const { exec } = organizationApi.deleteHoliday({
                params: { id },
                onSuccess: (response: any) => {
                    if (response.body.overlappingUsers && response.body.overlappingUsers.length > 0) {
                        if (callback.onSuccess) callback.onSuccess(response.body);
                        resolve(response.body);
                    } else {
                        if (callback.onSuccess) callback.onSuccess(response.body);
                        dispatch(deleteHoliday(id));
                        toastHandler.push('success', t('holiday.deleteHolidayTitle'), t('holiday.deleteHolidayMessage_Success'));
                        resolve(response.body);
                    }
                },
                onError: error => {
                    toastHandler.push('error', t('holiday.deleteHolidayTitle'), t('holiday.deleteHolidayMessage_Failed'));
                    reject(error);
                },
            });
            exec();
        });
    };

    return { exec };
};

export default useHttpDeleteHoliday;
